export default __webpack_public_path__ + "static/media/arrow.6e9a4008.svg";